export function isRateUnavailable(rate) {
    var blockedBySport = rate.get('isBlockedBySport');
    if (blockedBySport !== undefined && blockedBySport) {
        return true;
    }
    var blockedByLeague = rate.get('isBlockedByLeague');
    if (blockedByLeague !== undefined && blockedByLeague) {
        return true;
    }
    var blockedByMatch = rate.get('isBlockedByMatch');
    if (blockedByMatch !== undefined && blockedByMatch) {
        return true;
    }
    var blockedByGroup = rate.get('isBlockedByGroup');
    if (blockedByGroup !== undefined && blockedByGroup) {
        return true;
    }
    var blockedByOutcome = rate.get('isBlockedByOutcome');
    return !!(blockedByOutcome !== undefined && blockedByOutcome);
}
export function rateFactorChangeConfirmNeeded(rate) {
    var actualValue = rate.get('actualValue');
    var originalValue = rate.get('value');
    var blockedByRate = rate.get('isBlocked');
    if (actualValue === undefined || blockedByRate === false) {
        return false;
    }
    return actualValue !== originalValue;
}



// WEBPACK FOOTER //
// ./src/components/coupon/rateUtils.js